import React from "react";

export function Logout() {

    return <h1>Logging out</h1>
}